import { useEffect } from 'react';
import { useProfileMessages } from '../../../hooks/api/useProfileMessages';
import React from 'react';

export type UseProfileMessagingStateArgs = {
    selectedProfileIds: string[];
    onCancel: () => void;
    onClose: () => void;
};

export type UseProfileMessagingReturnValue = {
    onSend: () => void;
    isSendDisabled: boolean;
    message: string;
    setMessage: (message: string) => void;
    onCancel: () => void;
};

export default function useProfileMessagingState({
    selectedProfileIds,
    onCancel,
    onClose,
}: UseProfileMessagingStateArgs): UseProfileMessagingReturnValue {
    const [content, setContent] = React.useState('');
    const resetKey = selectedProfileIds.sort().join(',');
    useEffect(() => {
        setContent('');
    }, [resetKey]);
    const { sendMessage, isSendingMessage } = useProfileMessages({
        onSendMessageSuccess: () => {
            setContent('');
            onClose();
        },
    });

    const onSend = () => {
        sendMessage({
            message: content,
            medicalProfileIds: selectedProfileIds,
        });
    };

    return {
        onSend,
        isSendDisabled: !content || isSendingMessage,
        message: content,
        setMessage: setContent,
        onCancel: () => {
            onCancel();
            setContent('');
        },
    };
}
